import React, { useEffect, useState } from "react";

import type { MetaobjectField } from "@repo/shopify/types/generated/storefront.types";

import Link from "@atoms/Link";
import Loading from "@atoms/Loading";

import useMetaObjects from "@queries/useMetaObjects";

interface IProps {
  handle: string;
}

const MARKER_REGEX = /^([^\p{L}\p{N}\s]+)(\s+)/u;

export default function RecruitDetailContent({ handle }: IProps) {
  const [isMailClicked, setIsMailClicked] = useState(false);

  const { fetchMetaObjectHandle, metaObjectHandleData: data, metaObjectHandleLoading: loading } = useMetaObjects();

  useEffect(() => {
    void fetchMetaObjectHandle({ handle: { handle, type: "recruit" } });
  }, [handle]);

  const getValue = (fields: MetaobjectField[] | undefined, key: string) => {
    return fields?.find((item) => item.key === key);
  };

  const detailFields = getValue(data?.metaobject?.fields, "detail_fields")?.references?.edges;

  if (loading || !data) {
    return (
      <div className="flex flex-1 items-center justify-center">
        <Loading className="mt-0! mb-0!" type="more" />
      </div>
    );
  }

  return (
    <>
      <div className="scrollbar-hide flex flex-col gap-10 overflow-y-scroll pb-20">
        <div className="text-title flex flex-col whitespace-pre-line">
          {getValue(data.metaobject.fields, "title")?.value?.replace(/\\n/g, "\n")}
        </div>
        <div className="flex flex-col gap-5">
          {detailFields?.map((edge) => {
            if (edge?.node?.__typename !== "Metaobject") return null;

            const title = edge.node.fields.find((field) => field.key === "title")?.value || "";
            const description = edge.node.fields.find((field) => field.key === "description")?.value || "";

            return (
              <div className="tnt-gap-x pc:grid pc:grid-cols-4 flex flex-col" key={edge.node.id}>
                <span className="pc:col-span-1 col-span-2">{title}</span>
                <div className="pc:col-span-3 col-span-4">
                  {description.split("\n").map((line, index) => {
                    const match = line.match(MARKER_REGEX);
                    const marker = match?.[0] ?? "";
                    const rest = match ? line.slice(match[0].length) : line;

                    return (
                      <div className="flex" key={index}>
                        {marker && <span className="shrink-0 whitespace-pre">{marker}</span>}
                        <span className="min-w-0 flex-1 break-all whitespace-pre-wrap">{rest || " "}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="absolute bottom-0 left-0 w-full bg-white p-4 pt-5 dark:bg-black">
        <Link
          as="square"
          className="flex! w-full items-center justify-center text-center"
          href={`mailto:${getValue(data.metaobject.fields, "inquiry_mail")?.value}?cc=jp@thisisneverthat.com`}
          onClick={() => {
            setIsMailClicked(true);
          }}
        >
          {isMailClicked ? "メールが開かない場合は、直接お送りください。" : "応募する"}
        </Link>
      </div>
    </>
  );
}
